// extracted by mini-css-extract-plugin
export default {"main":"UserLogin_main__st671","loginCard":"UserLogin_loginCard__OJ5lx","registerDiv":"UserLogin_registerDiv__uOiZA","loginForm":"UserLogin_loginForm__0-9WZ"};